import { useState, useEffect, useCallback } from 'react'
import SidebarContext from './SidebarContext'

export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // Inicializar sidebar expandido por padrão, mas manter preferência entre páginas
  const [isExpanded, setIsExpanded] = useState(() => {
    try {
      const saved = localStorage.getItem('sidebar-expanded')
      // Se nunca foi definido, default é expandido (true)
      // Se já foi definido, mantém a preferência do usuário
      return saved !== null ? JSON.parse(saved) : true
    } catch {
      return true // Default expandido se erro no localStorage
    }
  })
  const [isMobileOpen, setIsMobileOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  const [activeItem, setActiveItem] = useState<string | null>(null)
  const [openSubmenu, setOpenSubmenu] = useState<string | null>(null)

  // Persistir preferência do sidebar no localStorage
  useEffect(() => {
    try {
      localStorage.setItem('sidebar-expanded', JSON.stringify(isExpanded))
    } catch {
      // Ignorar erro se localStorage não estiver disponível
    }
  }, [isExpanded])

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768
      setIsMobile(mobile)
      if (!mobile) {
        setIsMobileOpen(false)
      }
    }

    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const toggleSidebar = useCallback(() => {
    setIsExpanded((prev: boolean) => !prev)
  }, [])

  const toggleMobileSidebar = useCallback(() => {
    setIsMobileOpen(prev => !prev)
  }, [])

  const toggleSubmenu = useCallback((item: string) => {
    setOpenSubmenu(prev => (prev === item ? null : item))
  }, [])

  const collapseSidebar = useCallback(() => {
    if (isMobile) {
      setIsMobileOpen(false) // Fechar sidebar mobile
    } else {
      setIsExpanded(false) // Recolher sidebar desktop
    }
  }, [isMobile])

  return (
    <SidebarContext.Provider
      value={{
        isExpanded: isMobile ? false : isExpanded,
        isMobileOpen,
        isHovered,
        activeItem,
        openSubmenu,
        toggleSidebar,
        toggleMobileSidebar,
        setIsHovered,
        setActiveItem,
        toggleSubmenu,
        collapseSidebar,
      }}
    >
      {children}
    </SidebarContext.Provider>
  )
}
